// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2F5d5","notes":"Notes_notes__33Jwr","note":"Notes_note__2S7uN","markdown":"Notes_markdown__I3i2V"};